import { Smartphone } from "lucide-react";
import { cn } from "@/lib/cn";
import { useInstall } from "./useInstall";

/** "Install the app" entry for menus and the footer; hidden once installed or where it can't work. */
export function InstallAppLink({ className }: { className?: string }) {
  const { available, install } = useInstall();
  if (!available) return null;
  return (
    <button type="button" onClick={() => void install()} className={cn("inline-flex items-center gap-1.5 hover:text-ink", className)}>
      <Smartphone className="size-4" aria-hidden /> Install the app
    </button>
  );
}
